/** Строка материала в форме заявки в снабжение — как ввёл человек. */
export interface SupplyMaterialRow {
  name: string;
  unit: string;
  quantity: string;
}

export const EMPTY_MATERIAL_ROW: SupplyMaterialRow = { name: '', unit: '', quantity: '' };

/** Строки для payload: без пустых наименований, пустые поля — `null`. */
export function materialsForPayload(
  rows: SupplyMaterialRow[],
): { name: string; unit: string | null; quantity: string | null }[] {
  return rows
    .map((r) => ({ name: r.name.trim(), unit: r.unit.trim(), quantity: r.quantity.trim() }))
    .filter((r) => r.name.length > 0)
    .map((r) => ({ name: r.name, unit: r.unit || null, quantity: r.quantity || null }));
}
